<template>
  <div>
    <my-head></my-head>
    <div class="collection minH">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">我的收藏</span>
      </div>
      <div class="biao_ti">我的收藏</div>

      <el-table
        ref="multipleTable"
        :data="dataList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="项目名称">
          <template slot-scope="scope">
            <div class="flex-left-center ming_cheng">
              <!-- <div class="image flex-center">
                <img src="../assets/a.png" />
              </div> -->
              <div class="miao_xu">
                <!-- <div>{{ scope.row.markReleasePO.name }}</div> -->
                <router-link :to="`/details?id=${scope.row.markReleasePO.id}`">
                  {{ scope.row.markReleasePO.name }}
                </router-link>
                <div>暂无参数</div>
                <!-- <div>{{ scope.row.xiao }}</div> -->
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="权利人">
          <template slot-scope="scope">
            <div>{{ scope.row.markReleasePO.obligee }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="jiage" label="价格" width="180">
          <template slot-scope="scope">
            <div class="jia_ge" v-if="getListingDisplayPrice(scope.row.markReleasePO) || getListingDisplayPrice(scope.row.markReleasePO) === 0">
              {{ priceCurrencyPrefix(scope.row.markReleasePO.foreignType) }} {{ getListingDisplayPrice(scope.row.markReleasePO) }}
            </div>
            <div class="jia_ge" v-else>面议</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120">
          <template slot="header">
            <el-popconfirm
              title="确定删除选中的收藏?"
              @confirm="handleDeleteQb()"
            >
              <el-button slot="reference" size="mini" type="danger"
                >删除选中收藏</el-button
              >
            </el-popconfirm>
          </template>
          <template slot-scope="scope">
            <el-popconfirm
              title="确定删除这条收藏?"
              @confirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button slot="reference" size="mini" type="danger"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="flex-center fen_ye">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="dsize"
          layout="prev, pager, next, jumper"
          :total="dcount"
        >
        </el-pagination>
      </div>

      <div class="tui_jian">推荐项目</div>

      <div class="tj_list flex-between-left">
        <list-card
          :obj="item"
          v-for="(item, index) in introduction"
          :key="index"
        ></list-card>
      </div>
    </div>
    <my-footer> </my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import ListCard from "../components/ListCard.vue";
import { getRequest } from "../api/api";
import { priceCurrencyPrefix, getListingDisplayPrice } from "../api/util";
export default {
  name: "collection",
  components: {
    MyHead,
    MyFooter,
    ListCard,
  },
  data() {
    return {
      tableData: [
        {
          name: "专利",
          jiage: "510,000",
          da: "一种ETL流程中异常数据检测方法",
          xiao: "制造业,信息传输、软件和信息技术服务业",
        },
        {
          name: "中国科学院苏州纳米技术与纳米仿生研究所",
          jiage: "面议",
          da: "红外探测器及其制作方法",
          xiao: "专利",
        },
      ],
      multipleSelection: [],
      // 分页相关---------------------------
      currentPage: 1,
      dataList: [], //收藏列表
      dpage: 0,
      dsize: 10,
      dcount: 0,
      // -----------------------------------
      introduction: [], //推荐列表
    };
  },
  watch: {
    dpage() {
      this.getDataList();
    },
  },
  methods: {
    priceCurrencyPrefix,
    getListingDisplayPrice,
    // 获取收藏列表
    getDataList() {
      let data = {
        page: this.dpage,
        size: this.dsize,
      };
      getRequest({ url: "/api/v1/user/userCollectList", data }).then((res) => {
        if (res.errcode == 200) {
          this.dataList = res.data.ucs;
          this.dcount = res.data.count;
        }
      });
    },
    // 获取推荐列表
    patentList() {
      getRequest({ url: "/api/v1/markRelease/list" }).then((res) => {
        if (res.errcode == 200) {
          this.introduction = res.data.slice(0, 3);
        }
      });
    },
    // 选择
    handleSelectionChange(val) {
      // console.log("val", val);
      this.multipleSelection = val;
    },
    // 单条删除
    handleDelete(index, row) {
      console.log(index, row);
      let id = row.markReleasePO.id;
      this.deleteData(id);
    },
    // 多条删除
    handleDeleteQb() {
      console.log("选中项", this.multipleSelection);
      let arr = this.multipleSelection.map((item) => {
        return item.markReleasePO.id;
      });
      let id = arr.join(",");
      this.deleteData(id);
    },
    // 删除接口调用
    deleteData(id) {
      getRequest({ url: `/api/v1/user/deleteCollect?id=${id}` }).then((res) => {
        if (res.errcode == 200) {
          this.$message.success("删除成功");
          this.getDataList();
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 分页---------------------------
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.zrpage = val - 1;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.zrpage = val - 1;
    },
    // --------------------------------
  },
  created() {
    this.patentList();
    this.getDataList();
  },
};
</script>

<style lang="scss">
.collection {
  width: 80%;
  margin: 0 auto;
  padding: 35px 0 150px;
  .tui_jian {
    font-size: 18px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
  }
  .fen_ye {
    margin-top: 48px;
    margin-bottom: 80px;
  }
  .jia_ge {
    color: #eb5757;
    font-size: 18px;
    font-weight: 500;
    color: #eb5757;
  }
  .ming_cheng {
    .miao_xu {
      div:first-child {
        font-size: 16px;
        font-weight: 500;
        color: #1d2129;
        line-height: 24px;
        margin-bottom: 8px;
      }
      div:last-child {
        font-size: 13px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
      }
    }
    a {
      color: #333333;
    }
    .image {
      width: 80px;
      height: 80px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e5e6eb;
      margin-right: 24px;
      img {
        width: 72px;
        max-height: 72px;
      }
    }
  }
  .biao_ti {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
  }
}
</style>
